import React, { FC } from 'react';
import { Box } from '@mui/material';
import { IReviewNew, IReviewNewProps } from '../../shared/interfaces/IReviewNew';
import { IMonitoring } from '../../shared/interfaces/IMonitoring';
import { CommunityManagement } from '../../shared/interfaces/ICommunityManagement';
import { IGmbLocation } from '../../shared/interfaces/IGmbLocation';
import FacebookReview from './Type/FacebookReview';
import GolocalReview from './Type/GolocalReview';
import AerzteReview from './Type/AerzteReview';
import EKomiReview from './Type/EKomiReview';
import KununuReview from './Type/KununuReview';
import HolidayCheckReview from './Type/HolidayCheckReview';
import TripAdvisorReview from './Type/TripAdvisorReview';
import HotelsReview from './Type/HotelsReview';
import AirbnbReview from './Type/AirbnbReview';
import AmazondeReview from './Type/AmazondeReview';
import AppstoreReview from './Type/AppstoreReview';
import PlaystoreReview from './Type/PlaystoreReview';
import IndeedReview from './Type/IndeedReview';
import ExpediaReview from './Type/ExpediaReview';
import BookingReview from './Type/BookingReview';
import IdealoReview from './Type/IdealoReview';
import TrustedShopsReview from './Type/TrustedShopsReview';
import SanegoReview from './Type/SanegoReview';
import YelpReview from './Type/YelpReview';
import TrustPilotReview from './Type/TrustPilotReview';
import JamedaReview from './Type/JamedaReview';
import GlassdoorReview from './Type/GlassdoorReview';
import ShopauskunftReview from './Type/ShopauskunftReview';
import GoogleReview from './Type/GoogleReview';
import MobileReview from './Type/MobileReview';
import AutoscoutReview from './Type/AutoscoutReview';
import TellowsReview from './Type/TellowsReview';
import GooglePlace from './Type/GooglePlace';
import Check24 from './Type/Check24';
import EbayReview from './Type/EbayReview';
import CapterraReview from './Type/CapterraReview';
import FewoReview from './Type/FewoReview';
import GutebankenReview from './Type/GutebankenReview';
import JobvotingReview from './Type/JobvotingReview';
import TrivagoReview from './Type/TrivagoReview';
import OmrReview from './Type/OmrReview';
import GenericReview from './Type/GenericReview';

interface Props {
  reviews: IReviewNew[];
  monitoring: IMonitoring[];
  commentingModule: IReviewNewProps['commentingModule'];
  deletionModule?: boolean;
  hideHeader: boolean;
  hideFooter: boolean;
  location: IGmbLocation[];
  statusModule?: boolean;
  status: string[];
  selectedReviewIds?: string[];
  onReviewSelectionChange?: (reviewId: string, selected: boolean) => void;
}
const ReviewNew: FC<Props> = ({
  reviews,
  commentingModule,
  monitoring,
  location,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  selectedReviewIds = [],
  onReviewSelectionChange,
}) => {
  return (
    <Box>
      {reviews.map((reviewEntry: IReviewNew) => {
        if (reviewEntry.platform === 'stepstone') {
          return null;
        }

        const matchedMonitoring = monitoring.find((entry) => entry.company === reviewEntry.company);
        const communityManagement: CommunityManagement | undefined =
          matchedMonitoring?.communityManagement;
        // TODO: Backend must include tags in monitoring entries (see IMonitoring.tags)
        const tags = matchedMonitoring?.tags ?? [];

        if (hideFooter) {
          console.log('NF1', reviewEntry);
        }

        reviewEntry.selectionChecked = selectedReviewIds.includes(reviewEntry.id);
        reviewEntry.onSelectionChange = onReviewSelectionChange
          ? (selected: boolean) => onReviewSelectionChange(reviewEntry.id, selected)
          : undefined;

        const locationId =
          monitoring.find((entry) => entry.company === reviewEntry.company)?.id || '';

        reviewEntry.tags = tags;

        reviewEntry.currentStatus = reviewEntry.customStatus;

        const review = {
          facebook: (
            <FacebookReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          golocal: (
            <GolocalReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          aerzte: (
            <AerzteReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          ekomi: (
            <EKomiReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          airbnb: (
            <AirbnbReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          kununu: (
            <KununuReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          holidaycheck: (
            <HolidayCheckReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          tripadvisor: (
            <TripAdvisorReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          hotels: (
            <HotelsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          amazonde: (
            <AmazondeReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          appstore: (
            <AppstoreReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          playstore: (
            <PlaystoreReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          indeed: (
            <IndeedReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          expedia: (
            <ExpediaReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          booking: (
            <BookingReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          idealo: (
            <IdealoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          trustedshops: (
            <TrustedShopsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          sanego: (
            <SanegoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          yelp: (
            <YelpReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          trustpilot: (
            <TrustPilotReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          jameda: (
            <JamedaReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          glassdoor: (
            <GlassdoorReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          shopauskunft: (
            <ShopauskunftReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          google: (
            <GoogleReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              locationId={locationId}
              communityManagement={communityManagement}
              location={location}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          mobile: (
            <MobileReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          autoscout24: (
            <AutoscoutReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          tellows: (
            <TellowsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          googleplace: (
            <GooglePlace
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          check24: (
            <Check24
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          ebay: (
            <EbayReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          capterra: (
            <CapterraReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          fewo: (
            <FewoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          gutebanken: (
            <GutebankenReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          jobvoting: (
            <JobvotingReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          trivago: (
            <TrivagoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          omr: (
            <OmrReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            />
          ),
          default: (
            <GenericReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              communityManagement={communityManagement}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              statusModule={statusModule}
              status={status}
              deletionModule={deletionModule}
              reviewEntry={reviewEntry}
            ></GenericReview>
          ),
        };
        const reviewComponent =
          review[reviewEntry.platform as keyof typeof review] ?? review['default'];
        return <Box key={reviewEntry.id}>{reviewComponent}</Box>;
      })}
    </Box>
  );
};

export default ReviewNew;
